/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
export enum ERRORS {
  'generic' = 'generic',
  'notEnabledRoute' = 'not-enabled-route',
  'missingPage' = 'missing-page',
  'unauthorized' = 'unauthorized',
  'sessionExpired' = 'session_expired',
  'invalidProcess' = 'invalid_process',
  'notRegisteredCustomer' = 'not_registered_customer',
  'incompleteCustomer' = 'incomplete_customer'
}
